import { render, staticRenderFns } from "./listarInspeccionElementosExtintor.vue?vue&type=template&id=677a6810"
import script from "./listarInspeccionElementosExtintor.vue?vue&type=script&lang=js"
export * from "./listarInspeccionElementosExtintor.vue?vue&type=script&lang=js"
import style0 from "./listarInspeccionElementosExtintor.vue?vue&type=style&index=0&id=677a6810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports